import { useEffect } from 'react';

import { useRedirect } from '../useRedirect';

type RedirectProps = {
  to: string;
};
export function Redirect({ to }: RedirectProps) {
  const { redirect } = useRedirect();

  useEffect(() => redirect(to), []);
  return null;
}
